import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';
import { TimelineLite } from 'gsap';
import { throttle } from "underscore";

Snappy.Component.PlaylistNav = class PlaylistNav extends Snappy.BaseComponent {
    static get tagName() {
        return 'playlist-nav';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onResize();

    }

    setVars() {
        this.isOpened = false;


        this.$document = $(document);
        this.$toggleBtn = this.$element.find('.js-playlist-toggle');
        this.$panel = this.$element.find('.js-playlist-panel');
        this.$nextContainer = this.$element.find('.js-playlist-next-container');

        this.settings =  {
            transisionTime: 0.3,

        };

    }

    setDimensions() {
        this.wHeight = this.$window.height();
        this.panelWidth = this.$panel.width();
    }

    setEventListeners() {
        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );

        this.$document.on('scroll', throttle(this.throttleScroll.bind(this), 200));

        this.$toggleBtn.on('click', this.toggle.bind(this));

    }

    throttleScroll() {
        if (this.isOpened || App.isWidest) {
            this.updateShifts();
        }
    }

    toggle() {
        if (!this.isAnimating) {
            this.isAnimating = true;
            this.$element.addClass('is-animating');
            this.tween = new TimelineLite({onComplete: this.animationComplete.bind(this)});
            this[this.isOpened ? 'close' : 'open']();
        }
    }

    close() {
        this.isOpened = false;
        this.$body.removeClass('is-blocked-mobile');
        if (!App.isTablet) {
            this.restoreScrollPos();
        }
        this.$toggleBtn.removeClass('is-active');
        this.$element.removeClass('is-opened');

        this.tween.to(
            this.$panel,
            this.settings.transisionTime,
            {
                x: this.panelWidth,
                clearProps: 'transform'
            }
        ).to(
            this.$nextContainer,
            this.settings.transisionTime,
            {
                marginRight: 0,
                delay: -1 * this.settings.transisionTime
            }
        );
        this.tween.play();

    }
    open() {
        this.isOpened = true;

        if (!App.isTablet) {
            this.saveScrollPos();
        }
        this.$body.addClass('is-blocked-mobile');
        this.updateShifts();

        this.tween.to(
            this.$panel,
            this.settings.transisionTime,
            { x: 0 }
        ).to(
            this.$nextContainer,
            this.settings.transisionTime,
            {
                marginRight: -1 * this.panelWidth,
                delay: -1 * this.settings.transisionTime
            }
        );
        this.tween.play();
        this.$toggleBtn.addClass('is-active');
        this.$element.addClass('is-opened');

        $(window).trigger('gtm:send', [ 'Playlist Navigation', 'Open', document.location.href]);
    }
    animationComplete() {
        this.isAnimating = false;
        this.$element.removeClass('is-animating');

    }

    onResize() {
        this.setDimensions();
        this.updateShifts();
    }

    updateShifts() {
        this.topOffset = this.$element[0].getBoundingClientRect().top;
        const h = this.wHeight - this.topOffset;
        this.$panel.css({height: h + 10 });
    }

    saveScrollPos() {
        this.lastScrollPos = this.$document.scrollTop();
    }
    restoreScrollPos() {
        this.$document.scrollTop(this.lastScrollPos);
    }
}



// WEBPACK FOOTER //
// ./components/playlist-nav/scripts/playlist-nav.js